import React from 'react';
import { Description, Link } from '../../components/layouts';
import { getTrack } from '../../helpers';
import './style.scss';

const track = getTrack({ block: 2 });

export function Briefing() {
  return (
    <div className="page-section section-briefing inverted" data-track={track}>
      <div className="section-content center">
        <Description className="desc-1">
          第二代微云台，升级更稳了；搭载蔡司光学镜头，旗舰
          <br />
          芯片和全新OS系统，强势而来！
        </Description>
        {/* <Description className="desc-2">RMB 100/月或 RMB 8499 起，还可以折抵换购</Description>
        <Description className="desc-3">
          你可以立即在线购买并享受免费送货服务，
          <br />
          也可以预约到附近的 vivo Store 零售店够哦买。
        </Description> */}
        <div className="links">
          <Link bordered href="https://shop.vivo.com.cn/product/10006160" text="官网购买" position={2} />
          <Link bordered href="http://www.vivo.com.cn/store" text="门店购买" position={2} />
        </div>
      </div>
    </div>
  );
}
